import { useEffect, useState } from 'react';
import styles from './customerManagment.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { RiUserLine } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import { getAllParent } from 'services/get-all-parent';
import EmployProfileManagement from './employProfileManagement';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaSearch } from 'react-icons/fa';
import NotificationPad from 'components/notification/notificationPad';
interface Costumer {
    id: number;
    name: string;
    email: string;
    phone: string;
    isArchived: boolean;
}

type SortConfig = {
    key: 'name' | 'email' | 'phone' | null;
    direction: 'asc' | 'desc';
};

export default function CustomerTable() {
    const [costumers, setCostumers] = useState<Costumer[]>([]);
    const [sortConfig, setSortConfig] = useState<SortConfig>({ key: null, direction: 'asc' });
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedUserName, setSelectedUserName] = useState<string | null>(null);
    const [selectedUserArchived, setSelectedUserArchived] = useState<boolean | null>(null);

    const [showArchived, setShowArchived] = useState(false);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const handleUserClick = (id: number, name: string, isArchived: boolean) => {
        setSelectedUserId(id);
        setSelectedUserName(name);
        setSelectedUserArchived(isArchived)
    };

    const handleBackToTable = () => {
        setSelectedUserId(null);
        fetchData();
    };
    const fetchData = async () => {
        try {
            const costomerData = await getAllParent();
            if (costomerData.success && Array.isArray(costomerData.data)) {
                const processedData: Costumer[] = costomerData.data.map((item: { id: any; first_name: any; last_name: any; email: any; phone: any; isArchived: any }) => ({
                    id: item.id,
                    name: `${item.first_name} ${item.last_name}`.trim(),
                    email: item.email,
                    phone: item.phone,
                    isArchived: item.isArchived
                }));
                setCostumers(processedData);
            } else {
                console.error("Fehler beim Abrufen der daten", costomerData);
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        }
    };
    const sortedCostumers = [...costumers]
        .filter((costumer) => costumer.isArchived === showArchived)
        .filter((costumer) => {
            const name = costumer.name ? costumer.name.toLowerCase() : '';
            const email = costumer.email ? costumer.email.toLowerCase() : '';
            const phone = costumer.phone ? costumer.phone.toLowerCase() : '';
            const query = searchQuery.toLowerCase();

            return (
                name.includes(query) ||
                email.includes(query) ||
                phone.includes(query)
            );
        })
        .sort((a, b) => {
            if (sortConfig.key) {
                let aValue = a[sortConfig.key] || '';
                let bValue = b[sortConfig.key] || '';

                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            }
            return 0;
        });


    const handleSort = (key: 'name' | 'email' | 'phone') => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    useEffect(() => {
        fetchData();
    }, []);

    if (selectedUserId !== null) {
        return (
            <EmployProfileManagement id={selectedUserId} name={selectedUserName ?? ''} isArchived={selectedUserArchived ?? false} onBack={handleBackToTable} />
        );
    }
    return (
        <div className={styles.container}>
            {!showArchived &&
                <div className={styles.sectionHeader}>
                    <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                        <RiUserLine className={commonStyles.sectionTitleIcon} />
                        <h1>Nutzerverwaltung</h1>
                    </div>
                    <div className={styles.searchAndNotifyContainer}>
                        <div className={styles.notifyContainer}>
                            <NotificationPad />
                        </div>

                        <div className={styles.searchContainer}>
                            <div className={styles.searchBox}>
                                <FaSearch className={styles.searchIcon} />
                                <input
                                    type="text"
                                    placeholder="Suchen ..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className={styles.searchInput}
                                />
                            </div>
                        </div>
                    </div>
                </div>}
            {showArchived && <>
                <div className={styles.navigation}>
                    <p onClick={() => setShowArchived(false)}>Nutzerverwaltung</p> <IoIosArrowForward /> Archiv
                </div>
                <div className={styles.sectionHeader}>
                    <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                        <h1> Archivierte Nutzer</h1>
                    </div>
                    <div className={styles.searchContainer}>
                        <div className={styles.searchBox}>
                            <FaSearch className={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Suche..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>
            </>}
            <div className={styles.tbodyContainer}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th onClick={() => handleSort('name')}>
                                Name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                            </th>
                            <th onClick={() => handleSort('email')}>
                                E-Mail {sortConfig.key === 'email' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                            </th>
                            <th onClick={() => handleSort('phone')}>
                                Telefon {sortConfig.key === 'phone' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedCostumers.map((costumer, index) => (
                            <tr key={index} onClick={() => handleUserClick(costumer.id, costumer.name, costumer.isArchived)}>
                                <td>{costumer.name}</td>
                                <td>{costumer.email}</td>
                                <td><div className={styles.tdCont}>{costumer.phone}<IoIosArrowForward /></div></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className={styles.addButtonContainer} >
                <button
                    type="button"
                    className={`${commonStyles.commonButton} ${styles.addButton}`}
                    onClick={() => setShowArchived(!showArchived)}
                >{showArchived
                    ? <>
                        <FaArrowAltCircleLeft className={` ${styles.buttonIcon}`} />
                        <span>Zurück</span>
                    </>
                    : <>
                        <span>Archiv </span>
                        <FaArrowAltCircleRight className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </>}
                </button>
            </div>
        </div>
    );
}
